<template>
  <b-card>
    <template #header>
      <div class="row justify-content-between">
        <div class="col-auto">
          Lista
          <b-badge variant="success" class="mr-2">{{ labelHeader }}</b-badge>
        </div>
        <div class="col-auto">
          <b-button
            class="ml-2"
            @click="exibeHistoricoPedidos"
            variant="primary"
          >
            <BootstrapIcon icon="clock-history" color="white" />
            Histórico de Pedidos
          </b-button>
        </div>
      </div>
    </template>
    <b-col class="col-md-12 col-sm-12 col-lg-12">
      <div v-show="this.error" class="error-banner">
        Token inválido. Tente novamente ou contacte o suporte!
      </div>
      <div v-show="!this.error" :key="key">
        <b-overlay :show="show_overlay" rounded="sm">
          <DataTable
            v-model:selection="selectedCampanha"
            v-model:expandedRows="expandedRows"
            @rowExpand="onRowExpand"
            @rowCollapse="onRowCollapse"
            :value="list"
            class="p-datatable-sm"
            responsiveLayout="scroll"
            selectionMode="single"
            dataKey="id"
            :paginator="true"
            :rows="10"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 50]"
          >
            <Column header="Nome" field="nome" :sortable="true">
              <template #body="item">
                <div>
                  {{ item.data.nome }}
                </div>
              </template>
            </Column>
            <Column
              header="Identificação"
              field="identificacao"
              :sortable="true"
            >
              <template #body="item">
                <div>
                  {{ item.data.identificacao }}
                </div>
              </template>
            </Column>
            <Column header="Data Ínicio" field="data_ini" :sortable="true">
              <template #body="item">
                <div>
                  {{
                    moment(item.data.data_ini, 'YYYY-MM-DD H:mm').format(
                      'DD/MM/YYYY H:mm',
                    )
                  }}
                </div>
              </template>
            </Column>
            <Column header="Data Fim" field="data_fim" :sortable="true">
              <template #body="item">
                <div>
                  {{
                    moment(item.data.data_fim, 'YYYY-MM-DD H:mm').format(
                      'DD/MM/YYYY H:mm',
                    )
                  }}
                </div>
              </template>
            </Column>
            <Column header="Tempo restante" field="">
              <template #body="item">
                <CountDown
                  :key="key"
                  :campanha_id="item.data.id"
                  :date="item.data.data_fim"
                  @onFinish="fimDaCampanha"
                />
              </template>
            </Column>
            <Column header="Status" field="status" :sortable="true">
              <template #body="item">
                <div>
                  {{ item.data.status }}
                </div>
              </template>
            </Column>
            <Column field="Ações" :style="{ width: '200px' }" :sortable="false">
              <template #body="item">
                <PrimeButton
                  title="Exportar Produtos"
                  class="p-button-rounded p-button-info mr-2 px-2 py"
                  @click="downloadProdutos(item.data)"
                >
                  <BootstrapIcon icon="file-earmark-arrow-down" color="white" />
                </PrimeButton>
                <PrimeButton
                  title="Listar Pedidos Para Esta Campanha"
                  icon="pi pi-shopping-cart"
                  class="p-button-rounded p-button-success mr-2"
                  @click="abreListagemFarmacias(item.data)"
                />
              </template>
            </Column>
          </DataTable>
        </b-overlay>
      </div>
    </b-col>
  </b-card>
</template>

<script>
import { useRoute } from 'vue-router'
import service from '@/services/BaseService'
import config from '@/functions/formatMoney'
import { format } from 'v-money3'
import { utils, writeFileXLSX } from 'xlsx'
import moment from 'moment'
import CountDown from '@/components/CountDown.vue'

export default {
  components: { CountDown },
  setup() {
    const route = useRoute()
    return {
      route: route,
    }
  },
  data() {
    return {
      config: config,
      format: format,
      moment: moment,
      selectedCampanha: {},
      table: 'CAM_CAMPANHA',
      labelHeader: 'Campanha',
      key: 0,
      key_countDown: 0,
      error: false,
      show_overlay: false,
      list: [],
      item: {},
      expandedRows: [],
      fields: [],
      farmaciaID: this.$store.getters['user'][0].id,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    exibeHistoricoPedidos() {
      const farmacia_matriz_id = this.$store.getters['user'][0].id
      this.$router.push({
        path: `/historico-pedidos/${farmacia_matriz_id}`,
        name: 'Historico de Pedidos',
        params: {
          farmacia_matriz_id: farmacia_matriz_id,
        },
      })
    },
    abreListagemFarmacias(campanha) {
      this.$router.push({
        name: 'Lista de Pedidos de Filiais',
        path: `/pedido-farmacias/${campanha.id}/${this.farmaciaID}`,
        params: {
          campanha_id: campanha.id,
          farmacia_matriz_id: this.farmaciaID,
        },
      })
    },
    async getCampanhasNaoIniciadas() {
      try {
        const hoje = moment(new Date())

        const CAMP_NAO_INICIADA = 2
        const CAMP_ATIVA = 3
        this.show_overlay = true
        var http = new service(
          `CAM_CAMPANHA/search/params?cam_campanha_status_id=${CAMP_NAO_INICIADA}`,
        )
        await http
          .find()
          .then(async (resp) => {
            resp.data.response.forEach(async (campanha) => {
              var dataIni = moment(campanha.data_ini, 'YYYY-MM-DD H:mm')
              if (hoje.diff(dataIni, 'seconds') > 0) {
                var http = new service(`default/CAM_CAMPANHA`)
                await http.update(campanha.id, {
                  cam_campanha_status_id: CAMP_ATIVA,
                })
              }
            })

            this.show_overlay = false
            this.key++
          })
          .catch(() => {
            this.error = true
            this.show_overlay = false
            this.key++
          })
      } catch {
        this.error = true
        this.show_overlay = false
        this.key++
      }
    },
    async getList() {
      await this.getCampanhasNaoIniciadas()
      const CAMP_ATIVA_ID = 3
      this.show_overlay = true
      var http = new service(
        `CAM_CAMPANHA/search/params?cam_campanha_status_id=${CAMP_ATIVA_ID}`,
      )
      await http
        .find()
        .then(async (resp) => {
          this.list = resp.data.response
          this.show_overlay = false
          this.key++
        })
        .catch(() => {
          this.error = true
          this.show_overlay = false
          this.key++
        })

      this.list?.forEach(async (campanha) => {
        campanha.status = campanha.cam_campanha_status_descricao
      })
      this.list?.sort((a, b) => {
        return new Date(a.data_fim) - new Date(b.data_fim)
      })
    },
    async fimDaCampanha(campanha_id) {
      const STATUS_ENCERRADO = 5
      var http = new service(`default/CAM_CAMPANHA`)
      const obj = {
        cam_campanha_status_id: STATUS_ENCERRADO,
      }
      await http.update(campanha_id, obj)
    },
    async abreFormPedido(campanha) {
      const farmaciaUsuario = await this.getFarmaciaUsuario()
      const pedidoUsuario = await this.getPedidoFarmacia(
        campanha,
        farmaciaUsuario,
      )

      this.$store.commit({
        type: 'setHiperfarmaPedidoUsuario',
        value: {
          ...pedidoUsuario,
          valor_minimo: campanha.valor_minimo,
          obs: campanha.obs,
          preco_final_st: campanha.preco_final_st,
        },
      })

      await this.$router.push({
        path: '/pedido-usuario-hiperfarma',
        name: 'Pedido Usuário Hiperfarma',
      })
    },
    async getPedidoFarmacia(campanha, farmacia) {
      var pedido = {}
      var http = new service(
        `default/CAM_PEDIDO/search/params?cam_campanha_id=${campanha.id}&farmacia_id=${farmacia.id}`,
      )
      await http.find().then((res) => {
        pedido = res.data.response[0]
      })

      if (!pedido) {
        pedido = {
          cam_campanha_id: campanha.id,
          farmacia_id: farmacia.id,
        }
      }

      return pedido
    },
    async getFarmaciaUsuario() {
      var farmacia = {}
      const http = new service(
        `default/FIN_CLIENTE/search/params?id=${this.farmaciaID}`,
      )
      await http
        .find()
        .then((resp) => {
          farmacia = resp.data.response[0]
        })
        .catch((error) => {
          console.log(error)
        })

      return farmacia
    },
    newItem() {
      this.item = {}
      this.$router.push(`/novacampanha`)
    },
    updateItem(item) {
      this.item = item
      this.$router.push(`/campanha/${item.id}`)
    },
    async getCNPJS() {
      this.show_overlay = true
      var farmaciaMatriz = {}
      const httpFarmacia = new service(
        `default/FIN_CLIENTE/search/params?id=${this.farmaciaID}`,
      )
      await httpFarmacia.find().then((resp) => {
        farmaciaMatriz = resp.data.response[0]
      })

      var cnpjs = []
      if (farmaciaMatriz) {
        var http = new service(
          `default/FIN_CLIENTE/search/params?&email=${farmaciaMatriz.email}&nomereduzido=hiperfarma&limit=999&diff_classe=03&sort=nomereduzido`,
        )
        await http.find().then((resp) => {
          cnpjs = resp.data.response.map((item) => {
            return item.cnpjcpf
          })
        })
      } else {
        this.$toast.warning(
          'Ocorreu um erro ao buscar os CNPJs das farmácias filiais!',
        )
      }

      this.show_overlay = false

      return cnpjs
    },
    async downloadProdutos(item) {
      const cnpjs = await this.getCNPJS()
      var listaProdutos = []
      var http = new service(
        `default/CAM_CAMPANHA_PRODUTO/search/params?cam_campanha_id=${item.id}&limit=999&sort=descricao`,
      )
      await http.find().then((resp) => {
        // precisa mapear cada cpnj para cada produto
        listaProdutos = resp.data.response.map((produto) => {
          return cnpjs.map((cnpj) => {
            return {
              cnpj: cnpj,
              cean: produto.cean,
              descricao: produto.descricao,
              valor_unitario: produto.valor_unitario,
            }
          })
        })

        listaProdutos = [].concat.apply([], listaProdutos)
        listaProdutos.sort((a, b) => {
          return a.cnpj - b.cnpj
        })
      })
      const fileName = `exportacao_Big_Linx_${item.id}.xlsx`
      const listExport = listaProdutos.map((item) => {
        // Layout do arquivo de acordo com o solicitado via email
        return {
          CNPJ: item.cnpj ? item.cnpj : '',
          LOJA: '',
          COD_PRODUTO: '',
          EAN: item.cean,
          'DESCRIÇÃO PRODUTO': item.descricao,
          QUANTIDADE: '',
          PREÇO: format(parseFloat(item.valor_unitario), config),
          DESCONTO: '',
          'LABORATÓRIO/INDÚSTRIA': '',
        }
      })
      const ws = utils.json_to_sheet(listExport)
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Data')
      writeFileXLSX(wb, fileName)
    },
  },
  watch: {
    selectedCampanha() {
      this.key++
    },
  },
}
</script>
<style scopped>
p-row-toggler p-link {
  padding: 0rem 2rem;
}

.error-banner {
  background-color: #f8d7da;
  color: #721c24;
  padding: 0.75rem 1.25rem;
  border-color: #f5c6cb;
}
</style>
